
import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

interface StoryEditorEnglishContentProps {
  formState: any;
  onChange: (newState: any) => void;
}

const StoryEditorEnglishContent: React.FC<StoryEditorEnglishContentProps> = ({ 
  formState, 
  onChange 
}) => {
  const { language } = useLanguage();
  
  return (
    <div className="space-y-4">
      <h3 className="font-medium text-sm text-muted-foreground">
        {language === "en" ? "English Content" : "المحتوى الإنجليزي"}
      </h3>
      
      <div className="space-y-2">
        <label className="text-sm font-medium" htmlFor="title_en">
          {language === "en" ? "Title (English)" : "العنوان (الإنجليزية)"}
        </label>
        <Input 
          id="title_en"
          value={formState.title_en} 
          onChange={(e) => onChange({ ...formState, title_en: e.target.value })}
        />
      </div>
      
      <div className="space-y-2">
        <label className="text-sm font-medium" htmlFor="summary_en">
          {language === "en" ? "Summary (English)" : "الملخص (الإنجليزية)"}
        </label>
        <Textarea 
          id="summary_en"
          value={formState.summary_en} 
          onChange={(e) => onChange({ ...formState, summary_en: e.target.value })}
          className="min-h-24"
        />
      </div>
      
      <div className="space-y-2">
        <label className="text-sm font-medium" htmlFor="content_en">
          {language === "en" ? "Content (English)" : "المحتوى (الإنجليزية)"}
        </label>
        <Textarea 
          id="content_en"
          value={formState.content_en} 
          onChange={(e) => onChange({ ...formState, content_en: e.target.value })}
          className="min-h-40"
        />
      </div>
    </div>
  );
};

export default StoryEditorEnglishContent;
